/* @generated from adl module ferovinum.sourcecontracts.expensestatusevent */

import * as ADL from './../../runtime/adl';
import * as common from './../../common';
import * as common_strings from './../../common/strings';
import * as ferovinum_app_db from './../app/db';

/**
 * The published `source__app_db.expense_status_event` contract.
 */
export interface ExpenseStatusEventSource {
  id: ferovinum_app_db.ExpenseStatusEventId;
  expenseId: ferovinum_app_db.ExpenseId;
  status: common_strings.StringNE;
  transitionedAt: common.Instant;
  createdAt: common.Instant;
  updatedAt: common.Instant;
}

export function makeExpenseStatusEventSource(
  input: {
    id: ferovinum_app_db.ExpenseStatusEventId,
    expenseId: ferovinum_app_db.ExpenseId,
    status: common_strings.StringNE,
    transitionedAt: common.Instant,
    createdAt: common.Instant,
    updatedAt: common.Instant,
  }
): ExpenseStatusEventSource {
  return {
    id: input.id,
    expenseId: input.expenseId,
    status: input.status,
    transitionedAt: input.transitionedAt,
    createdAt: input.createdAt,
    updatedAt: input.updatedAt,
  };
}

const ExpenseStatusEventSource_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.sourcecontracts.expensestatusevent","decl":{"annotations":[{"value":{"modelName":"source__app_db.expense_status_event","grain":["id"],"tags":["revenue","source"]},"key":{"moduleName":"ferovinum.sourcecontracts.common","name":"SourceContract"}},{"value":["notes","user_id"],"key":{"moduleName":"ferovinum.sourcecontracts.common","name":"UnpublishedColumns"}},{"value":"The published `source__app_db.expense_status_event` contract.\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"id","default":{"kind":"nothing"},"name":"id","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"ExpenseStatusEventId"}},"parameters":[]}},{"annotations":[],"serializedName":"expenseId","default":{"kind":"nothing"},"name":"expenseId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"ExpenseId"}},"parameters":[]}},{"annotations":[],"serializedName":"status","default":{"kind":"nothing"},"name":"status","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"transitionedAt","default":{"kind":"nothing"},"name":"transitionedAt","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[],"serializedName":"createdAt","default":{"kind":"nothing"},"name":"createdAt","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[],"serializedName":"updatedAt","default":{"kind":"nothing"},"name":"updatedAt","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}}]}},"name":"ExpenseStatusEventSource","version":{"kind":"nothing"}}};

export const snExpenseStatusEventSource: ADL.ScopedName = {moduleName:"ferovinum.sourcecontracts.expensestatusevent", name:"ExpenseStatusEventSource"};

export function texprExpenseStatusEventSource(): ADL.ATypeExpr<ExpenseStatusEventSource> {
  return {value : {typeRef : {kind: "reference", value : snExpenseStatusEventSource}, parameters : []}};
}

export const _AST_MAP: { [key: string]: ADL.ScopedDecl } = {
  "ferovinum.sourcecontracts.expensestatusevent.ExpenseStatusEventSource" : ExpenseStatusEventSource_AST
};
